import React, { Component } from 'react';
import axios from "axios";

import InfoTextWidget from '@components/InfoTextWidget';
import InfoNumberWidget from '@components/InfoNumberWidget';
import BarChartWidget from '@components/BarChartWidget';
import PieChartWidget from '@components/PieChartWidget';
import TableWidget from '@components/TableWidget';

import styles from './dashboard.module.css';

const researcherBaseServiceURL =
  /* `axios` is a popular JavaScript library used for making HTTP requests from the browser. In this
  code snippet, `axios` is being used to create instances of Axios for making API requests to
  different endpoints. It is used to fetch data from the specified URLs and handle the responses
  asynchronously. */
  axios.create({
    baseURL: process.env.REACT_APP_RESEARCHER_DASHBOARD_MICROSERVICE_URL +  process.env.REACT_APP_SERVICES_VERSION + '/researcherdashboardservice'
  });



class Dashboard extends Component {
  state = {
    correspondentsOverallProgress: [],
    correspondentsCompletedSurveys: [],

  }
  constructor() {
    super();
    function parseJwt(token) {
      var base64Payload = token.split('.')[1];
      var payload = Buffer.from(base64Payload, 'base64');
      return JSON.parse(payload.toString());
    }


    let bearer = localStorage.getItem('Bearer');

    if (!bearer){
      window.location = "/login";
  
    }

    let payload = parseJwt(bearer);

    let orgID = payload.org_id;
    let sector_id = payload.sector_id;
    let surveycycle = process.env.REACT_APP_CURRENT_SURVEY_CYCLE;


    let researcherCorrespondentsStatus = process.env.REACT_APP_RESEARCHER_DASHBOARD_MICROSERVICE_URL +  process.env.REACT_APP_SERVICES_VERSION + `/researcherdashboardservice/correspondents/surveycycle/${surveycycle}`;
    let researcherCorrespondentsStatusURL = axios.create({ baseURL: researcherCorrespondentsStatus });
    


    let researcherCompletedSurveys = process.env.REACT_APP_RESEARCHER_DASHBOARD_MICROSERVICE_URL +  process.env.REACT_APP_SERVICES_VERSION + `/researcherdashboardservice/completedsurveys/surveycycle/${surveycycle}`;
    let researcherCompletedSurveysURL = axios.create({ baseURL: researcherCompletedSurveys });


    researcherCorrespondentsStatusURL.get('').then(
      resp => {
        const respData = resp.data;
        let correspondentsProgressData = [];

        if (respData.status == "SUCCESS" && respData.response.success.length > 0) {
          respData.response.success.forEach(record => {
            correspondentsProgressData.push(record);
          });
        }

        this.setState({
          correspondentsOverallProgress: correspondentsProgressData,
        });

      }
    );

    researcherCompletedSurveysURL.get('').then(
      resp => {
        const respData = resp.data;

        let completedSurveys = [];
        if (respData.status == "SUCCESS") {
          respData.response.success.forEach(record => {
            completedSurveys.push(record);
          });
        }

        this.setState({
          correspondentsCompletedSurveys: completedSurveys,
        });

      }
    );

    let organisationNameUrl = process.env.REACT_APP_SURVEY_MICROSERVICE_URL +  process.env.REACT_APP_SERVICES_VERSION + "/questionnaireservice/questionnairetrackers/organisation/name/" + orgID;
    let sectorNameUrl = process.env.REACT_APP_SURVEY_MICROSERVICE_URL +  process.env.REACT_APP_SERVICES_VERSION + "/questionnaireservice/questionnairetrackers/sector/name/" + sector_id;

    if (orgID) {

      axios.get(organisationNameUrl)
        .then(response => {
          localStorage.setItem('organisationName', response.data.name);
        });
    }

    if (sector_id) {

      axios.get(sectorNameUrl)
        .then(response => {
          localStorage.setItem('sectorName', response.data.name);
        });
    }


  }



  render() {

    let correspondentsOverallProgressChartDataPie = this.state.correspondentsOverallProgress;

    let latestCompletedSurveys = this.state.correspondentsCompletedSurveys;

    let columns = [
      { label: "Organisation", name: "Organisation" },
      { label: "Date Completed", name: "DateChecked" },
    ];

    return (
      <div className={styles.dashboard_overview_container}>


        <div className={styles.flex_row_container}>

          < TableWidget title="Latest Completed Surveys" rows={latestCompletedSurveys} columns={columns} />
          <BarChartWidget
                            headerTitle="Overall Progress"
                            data={correspondentsOverallProgressChartDataPie}
                            toolTip="Number of questionnaires started and not started by respondents"
                            headerTitleYear=""
                            dateToolTip="Charts display data only when survey for reference year is submitted."
                            xAxis="Name"
                            dataKey1="Value"
                        />

        
        </div > 



      </div >
    )
  }
}

export default Dashboard

